import React from 'react';

import { type OnCloseHandler } from '@atlaskit/modal-dialog';

import type { IconData } from '../types';

import { BaseLegacyIconDetails } from './base-legacy-icon-details';
export type LegacyIconDetailsProps = {
	icon?: IconData;
	testId?: string;
	isModal?: boolean;
	onClose?: OnCloseHandler;
};

/**
 * __Legacy icon details__
 *
 * A panel which is populated when a legacy icon is selected.
 * Contains information about the legacy icon. *
 */
const LegacyIconDetails = ({
	icon,
	isModal,
	onClose,
	testId,
}: LegacyIconDetailsProps): React.JSX.Element => {
	return <BaseLegacyIconDetails icon={icon} testId={testId} isModal={isModal} onClose={onClose} />;
};

export default LegacyIconDetails;
